module.exports = "\n<canvas #canvas></canvas>  \n\n\n\n"